import React, { Component } from 'react';
import { Parallax } from 'react-parallax';
import HalfSection from './HalfSection';
import GreenSection from './GreenSection';
import Map2 from './Map2';
import Modal from 'react-modal';
import ReactGA from 'react-ga';
import Social from './Social';


import '../css/App.css';
//import '../css/App.scss';

import logo from '../img/logo.gif';
import logoMSD from '../img/logo-msd.gif';

import Rings from '../img/rings.png';

//import half from '../img/half.svg';
//import threefour from '../img/34.svg';

import quote11 from '../img/Group.png';

import bgceo from '../img/ceo.jpg';
import playBTN from '../img/btn-play.svg';

import logos1 from '../img/logos1.png';
import logos2 from '../img/logos2.png';
import logos3 from '../img/logos3.png';
import logos4 from '../img/logos4.png';
import logos5 from '../img/logos5.png';

import logosMobile from '../img/logos-mobile.png';

import signature from '../img/signature.png';

import womens1 from '../img/womens1.jpg';
import womens2 from '../img/voices2.jpg';
import womens3 from '../img/voices3.jpg';
import womens4 from '../img/voices4.jpg';

import merckLogo from '../img/merck_logo.png';
import msdLogo from '../img/msd_logo.png';


const MFM = true;



const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    padding               : 10,
    backgroundColor       : '#000',
    border                : 0,
    borderRadius          : 0,
    transform             : 'translate(-50%, -50%)',
    zIndex: 99999999

  },
  overlay: {
      backgroundColor: 'rgba(0,0,0,0.5)',
      zIndex: 99999998
    }
};


class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      scrolled: false,
      playing: false,
      playing2: false,
      playing3: false,
      video1: false,
      video2: false
    };

    this.countup1 = false;
    this.count = false;
    this.mapplay = false;

    this.number1 = false;
    this.number2 = false;
    this.number3 = false;
    this.number4 = false;
    this.number5 = false;

    this.isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

    this.wavesurfer = null;
    this.wavesurfer2 = null;
    this.wavesurfer3 = null;

    this.section3Height = 0;
    this.section4Height = 0;


    if(MFM) {
      this.MERCK = "Merck";
      this.NAME = "Merck for Mothers";
      this.BASE_URL = "https://reports.merckformothers.com/us/";
      this.TITLE = "The US Maternal Mortality Crisis: It's time to reverse the trend #EndMaternalMortality.";
      this.TWITTER_TITLE = "The US Maternal Mortality Crisis: It's time to reverse the trend #EndMaternalMortality.";
    } else {
      this.MERCK = "MSD";
      this.NAME = "MSD for Mothers";
      this.BASE_URL = "https://reports.msdformothers.com/us/";
      this.TITLE = "The US Maternal Mortality Crisis: It's time to reverse the trend #EndMaternalMortality.";
      this.TWITTER_TITLE = "The US Maternal Mortality Crisis: It's time to reverse the trend #EndMaternalMortality.";
    }


    this._scroll = this._scroll.bind(this);
    this._resize = this._resize.bind(this);
    this._play = this._play.bind(this);

    this._video1 = this._video1.bind(this);
    this._video2 = this._video2.bind(this);
    this._close = this._close.bind(this);
  }
  componentDidMount() {

    function initializeReactGA() {
      ReactGA.initialize('UA-25756456-1');
    }

    initializeReactGA();

    window.scroll(0,0);
    window.addEventListener("scroll", this._scroll, false);
    //window.addEventListener("resize", this._resize, false);



    if(window.innerWidth >= 800) {
      /*this.section3Height = this.refs.section3.offsetHeight;
      this.refs.section3.style.height = this.section3Height+window.innerHeight + "px";
      this.refs.section3quote.style.top = this.section3Height + "px";*/

      this.section4Height = this.refs.section4.offsetHeight;
      this.refs.section4.style.height = this.section4Height + "px";
      this.refs.section4quote.style.top = this.section4Height*0.5 + "px";
    }

  }
  render() {
    return (
      <div className="app">
        <div className="header"><a href={MFM ? "http://www.merckformothers.com" : "http://www.msdformothers.com"} target="_blank" rel="noopener noreferrer"><img src={MFM ? logo : logoMSD} /></a></div>
        <div className={this.state.scrolled ? "arrow bounce hide" : "arrow bounce"} />
        <div id="section1" className="flex double jarallax" data-jarallax-video="https://www.youtube.com/watch?v=eowHcu26PDw">

          <div ref="btnPlay" className="btn-play1"><button onClick={this._video1}><img src={playBTN} /></button></div>
          <div ref="rings" className="rings"><img src={Rings} /></div>
          <div ref="headerText" className="header-text">
            THE US MATERNAL HEALTH CRISIS:<br />
            IT'S TIME TO REVERSE THE TREND

            <div className="header-text-sub">
              A digital report by<br /><em>{this.MERCK} for Mothers</em>
            </div>

            <div className="section1-social"><Social mfm={MFM} title={this.TITLE} twitterTitle={this.TWITTER_TITLE} url={this.BASE_URL} /></div>
          </div>
        </div>
        <div id="section2" ref="section2" className="top-pad">
            <div className="section-inner p-fade">
              <div ref="rest1">
                <h1>A woman in America in 1990 had a better chance of surviving childbirth than her own daughter does today.<sup>(1)</sup></h1>
                <p>Today, far too many women around the world die while giving life. Maternal deaths do not only occur in remote corners of the globe, but right here in our own backyard – in a country with one of the best healthcare systems at the height of modern medicine.</p>
                <p>Even though the impact of maternal mortality is felt widely, it does discriminate. In America, the odds are stacked higher against a Black woman. She is 3-4 times more likely to lose her life as a result of pregnancy and childbirth than a White woman.</p>
                <p><em>{this.MERCK}</em> is a company that is committed to saving and improving lives, and we are continually inventing for a more hopeful tomorrow. <em>{this.MERCK} for Mothers</em> has worked with over 100 partners, in 30 countries, to find, test, scale and sustain solutions to reduce maternal mortality.</p>
                <p>Investing in maternal health will not only help save mothers' lives, it will improve the lives of her children and her children's children. It will strengthen her community. It will improve our world.</p>
                <p>This report is the first in a series on the state of maternal mortality in the United States and the critical work women and their families, health care providers, community health workers, advocates, policymakers and researchers are doing to reverse this trend. There is more to be done.  We invite you to learn more about <a href="http://merckformothers.com/usprograms.html" target="_blank" rel="noopener noreferrer">our work</a> and <a href="#join">join our efforts</a>.</p>
              </div>

              <div ref="rest3">
                <h1>Together, we can and we must make maternal mortality a thing of the past.</h1>

                <div className="signature">
                  <img src={signature} />
                  <span>Dr. Mary-Ann Etiebet<br />Lead & Executive Director, <em>{this.MERCK} for Mothers</em></span>
                </div>
              </div>
            </div>

        </div>

        <div className="almost-full jarallax" data-jarallax-video="https://www.youtube.com/watch?v=YbE7AEVuSmc">
            <div className="ceo-section flex section-full">
              <div>
                <div className="btn-play"><button onClick={this._video2}><img src={playBTN} /></button></div>
                <br />
                <h3>A message from our CEO, Ken Frazier</h3>
              </div>
            </div>
        </div>


        <div id="list" ref="list">
          <div id="list-title">
            <h1>Global Maternal Mortality Rates</h1>
            <h3>(Countries ranked from lowest to highest)</h3>
            <div className="orange-break"></div>
          </div>
          <div id="list-gradient"></div>
          <div className="list-inner">
            <ul>
            	<li>Finland</li>
            	<li>Greece</li>
            	<li>Iceland</li>
            	<li>Poland</li>
            	<li>Austria</li>
            	<li>Belarus</li>
            	<li>Czech Republic</li>
            	<li>Italy</li>
            	<li>Kuwait</li>
            	<li>Sweden</li>
            	<li>Israel</li>
            	<li>Japan</li>
            	<li>Norway</li>
            	<li>Spain</li>
            	<li>Switzerland</li>
            	<li>Australia</li>
            	<li>Denmark</li>
            	<li>Germany</li>
            	<li>Slovakia</li>
            	<li>United Arab</li>
            	<li>Belgium</li>
            	<li>Canada</li>
            	<li>Cyprus</li>
            	<li>Montenegro</li>
            	<li>Netherlands</li>
            	<li>Croatia</li>
            	<li>France</li>
            	<li>Ireland</li>
            	<li>The former Yugoslav Republic of Macedonia</li>
            	<li>Estonia</li>
            	<li>Libya</li>
            	<li>Malta</li>
            	<li>Slovenia</li>
            	<li>United Kingdom</li>
            	<li>Lithuania</li>
            	<li>Luxembourg</li>
            	<li>Portugal</li>
            	<li>Singapore</li>
            	<li>Bosnia and Herzegovina</li>
            	<li>Bulgaria</li>
            	<li>New Zealand</li>
            	<li>Republic of Korea</li>
            	<li>Kazakhstan</li>
            	<li>Saudi Arabia</li>
            	<li>Qatar</li>
            	<li>Puerto Rico</li>
            	<li id="usa" className="usa"><strong>United States of America</strong></li>
            </ul>
            <div className="social-bottom"><Social mfm={MFM} title={this.TITLE} twitterTitle={this.TWITTER_TITLE} url={this.BASE_URL} /></div>
          </div>
        </div>
        <div ref="green" className="green-area">
          <div className="green-area-inner">
            <div ref="green1" className="green-section green-section1">

              <div id="half60" className="half-60">60%</div>
              <span>60% of the maternal deaths in the U.S. are preventable<sup>(3)</sup></span>

            </div>
            <div ref="green2" className="green-section green-section2">
              <span>Black women are 3-4 times more likely to die during pregnancy and childbirth than White women<sup>(4)</sup></span>
              <div id="half34" className="half-34">3-4x</div>
            </div>
          </div>

          <div className="social-bottom"><Social mfm={MFM} title={this.TITLE} twitterTitle={this.TWITTER_TITLE} url={this.BASE_URL} /></div>
        </div>


        <div ref="section4" id="section4">
          <div className="bg"></div>
          <div ref="section4quote" className="section3-quote"><img src={quote11} /></div>
          <div ref="section4_left" className="section3-left">
            <div className="section3-inner">
              <h1>Building a better future of care for mothers </h1>

              <p>"There's no way to justify that level of disparity."</p>
              <p>Shanon McNab's voice carries a tone as grim as the statistic that she was reacting to.  </p>
              <p>"We learned that non-Hispanic Black women were 12 times more likely to die than White women in New York City," she says, citing the New York City Department of Health and Mental Hygiene <a href="https://www1.nyc.gov/assets/doh/downloads/pdf/ms/pregnancy-associated-mortality-report.pdf" target="_blank" rel="noopener noreferrer">report</a> on maternal deaths.</p>
              <p>As the Associate Director of Averting Maternal Death and Disability (AMDD) at Columbia University, McNab's research covers not just America's largest city, but the entire country where the alarming rise in maternal mortality has finally received an overdue spotlight on the national stage.  </p>
              <p>Harrowing stories from some of the world's most  beloved celebrities have helped  open up a public discourse that countless researchers, community-based organizations and advocates have long known about:  The U.S. has a  maternal health issue.</p>
              <p>The nationwide statistics are staggering.  Every year there are close to 60,000 near-deaths from pregnancy and childbirth-related causes.  Roughly two women die every day.  When <em>{this.MERCK} for Mothers</em> partnered with the CDC to help lead the <a href="https://www.cdcfoundation.org/sites/default/files/files/MMRIAReport.pdf" target="_blank" rel="noopener noreferrer">first-ever multi-state report</a> on maternal deaths, the CDC found that up to 60% percent of them were preventable.</p>
              <p>"A decade ago, the country was not paying attention to maternal mortality. We didn't understand the problem – or even know there was a problem -- because we did not have the data. Most states were not regularly tracking maternal deaths," said Dr. Etiebet, Lead and Executive Director of <em>{this.MERCK} for Mothers</em>.</p>
              <p>The data uncovered not only the decades long rise in maternal mortality, but the  disparities in health outcomes in the US healthcare system.  A Black woman is 3-4 times more likely to die from childbirth-related causes than a White woman. The CDC's analysis finds that on average, 3.7 critical factors contribute to a maternal death, the result of a fractured healthcare network.<sup>(5)</sup></p>
              <p>This frustrating fragmentation has led to conditions that exhaust both doctors and their patients. "There's too long of a wait for prenatal care," explained McNab. "Some women never see the same provider throughout their pregnancy and are unable to establish trust."  Long lines and red tape only adds further stress on the mother. "Women feel deeply disrespected to be forced to lose a day for an appointment and there are a myriad of practical reasons why they can't make every appointment."</p>
              <p>For Black women, the stresses are even higher. "Many women of color are not trusting of providers due to a history of mistreatment and disrespect. We need to listen to and value the voices of all women," said Dr. Etiebet. "We need to ask ourselves why there are racial disparities in health outcomes and what can we do to fix them." </p>
              <p>McNab believes collecting and studying the stories of Black women, as she does at AMDD, will provide a deeper understanding of the daily experiences they face. "There is a movement towards recognizing bias and racism within the healthcare system. But, addressing the problem is a real challenge," said McNab. "There is a huge opportunity to be more human and aware of how you talk to women. Powerful individual stories bring awareness."</p>
              <p>These stories are vital to putting more effective solutions in place. "Hospitals around the country are implementing evidence-based practices that help care teams respond quickly and effectively to obstetric emergencies," said Dr. Etiebet. "And <em>{this.MERCK} for Mothers</em> is working with partners to scale these tools to all 50 states, because every woman should be able to access high-quality care."</p>
              <p>A <a href="JavaScript:extLink('https://www1.nyc.gov/site/doh/about/press/pr2018/pr014-18.page');" rel="noopener noreferrer">new project focused on elevating women's voices</a> is also helping the country improve care for pregnant mothers. New York City has begun interviewing individual women who survived a life-threatening complication during pregnancy and childbirth. Going to women directly will shed much-needed light on their interactions with maternity care providers and identify opportunities for systemic change to prevent future tragedies. </p>
              <p>Furthermore, the recent discussion of maternal mortality in the media is a positive step in the right direction . "There is importance in the narrative journalists are framing," said Dr. Joia Crear-Perry, the Founder and President of the National Birth Equity Collaborative. "This is the first time we're hearing an honest conversation about how racism affects our healthcare, how the structures around valuing people with different skin colors impacts our health."</p>
              <p>She also believes involving the private sector in healthcare will make a big impact and benefit all citizens. "<em>{this.MERCK} for Mothers</em> is investing in moms and women and children around the world."</p>
              <p>Dr. Crear-Perry is optimistic about the changing culture, including recent policy efforts to prevent maternal mortality. "Right now, there is a bill being put forth in Congress that addresses disparities based on race by requiring hospital staff to receive bias training and another bill which aims to help with funding."</p>
              <p>She ends with this. "If we can learn how to value Black women in the U.S., we can translate that globally."</p>
            </div>
          </div>
          <div className="social-bottom"><Social mfm={MFM} title={this.TITLE} twitterTitle={this.TWITTER_TITLE} url={this.BASE_URL} /></div>
        </div>


        <div ref="purple" className="purple-area">
          <div className="purple-area-inner">
            <h1>MOTHERS' VOICES</h1>

            <p>We can learn so much from mothers embarking on their journey to motherhood as well as their advocates and community health workers who provide support and affirmation. When we listen and respond to the needs of all women, our solutions become stronger. </p>

            <div ref="purple1" className="purple-list wrap">
              <div className="left">
                <img src={womens1} alt="womens1" />
              </div>
              <div className="purple-list-text right">
                <h3>The doctor's visit</h3>
                <p>I often accompany women to their medical appointments. The women we work with often face a lot of stigmatization within the health care system and have usually experienced judgment and negative attitudes from one of their health care providers...</p>
                <p>For this reason women often come armed by donning the mask of toughness and defensiveness, with an air of impenetrability.</p>
                <p>It's amazing how quickly that defensive armor can be shed when a provider shows compassion and respect and listens to the patient's story instead of creating their own.</p>
                <p><em>Community Health Worker, Camden NJ</em></p>
              </div>
            </div>

            <div ref="purple2" className="purple-divider"></div>

            <div ref="purple3" className="purple-list wrap">
              <div className="left">
                <img src={womens2} alt="womens2" />
              </div>
              <div className="purple-list-text right">
                <h3>THIS IS WHERE I STARTED TO HEAL</h3>
                <p>I walked down this road to Cooper Hospital not knowing what to expect. I was hurting, physically and emotionally. I was scared and broken. This two block walk felt like 200 miles, but I made it there and made it inside. I asked for help and received it with welcoming arms. This is where I learned to open my mouth, this is where I started to get my voice back, this is where I became involved with the Camden Coalition, this is where I found out my beautiful baby boy would be here in a few short months.</p>
                <p><em>Client, Camden NJ</em></p>
              </div>
            </div>

            <div ref="purple4" className="purple-divider"></div>

            <div ref="purple5" className="purple-list wrap">
              <div className="left">
                <img src={womens3} alt="womens3" />
              </div>
              <div className="purple-list-text right">
                <h3>SEE ME LIKE I SEE YOU</h3>
                <p>As a community health worker, I am in the position of being able to offer support to moms-to-be during what is often an incredibly challenging and transformative time in their lives. I recognize my special role of being a consistent and kind support to people during these moments, and the phrase “see me like I see you" guides me as I aim to bring to the surface all the positivity and strengths each and every one of the women I work with embody.</p>
                <p><em>Community Health Worker, Philadelphia</em></p>
              </div>
            </div>

            <div ref="purple6" className="purple-divider"></div>

            <div ref="purple7" className="purple-list wrap">
              <div className="left">
                <img src={womens4} alt="womens4" />
              </div>
              <div className="purple-list-text right">
                <h3>FINDING BALANCE IS AN EVER REVOLVING PROCESS</h3>
                <p>Overall, this whole thing scared me. I was not ready to have a second child. Despite the surrounding struggles, I found an inner peace by just accepting my life role as a mother of two. I was scared and nervous, but finding balance was my main goal. [My community health workers] helped me retain the necessities for my children and find peace with my new status of being medically prohibited to work. Finding balance is an ever revolving process.</p>
                <p><em>Client, New York City</em></p>
              </div>
            </div>


            <div className="center-it">
            <ReactGA.OutboundLink
                  eventLabel="MFM-MothersVoices.pdf"
                  to="http://reports.merckformothers.com/us/docs/MFM-MothersVoices.pdf" 
                  target="_blank" 
                  className="link-btn-white"
                  rel="noopener noreferrer">Read More
                </ReactGA.OutboundLink>
            </div>

          </div>
        </div>




        <div ref="section6" id="section6">
          <div className="bg"></div>
          {/*<div ref="section4quote" className="section3-quote"><img src={quote11} /></div>*/}
          <div ref="section6_left" className="section6-right">
            <div className="section6-inner">
              <h1><em>{this.MERCK} for Mothers</em> in the US</h1>

              <p><em>{this.MERCK} for Mothers</em> is tackling the leading contributors to maternal mortality and morbidity in the US: lack of data; inconsistent obstetric care; increase in chronic conditions; and limited awareness of the problem. We're working with partners across sectors to design and test innovations, scale promising solutions, and elevate women's voices in policy and practice to ensure every woman has access to quality care, no matter where she gives birth.</p>

              <h3>Better Data</h3>

              <p><em>{this.MERCK} for Mothers</em> is working with partners to build the capacity of states to review maternal deaths, understand why women are dying and translate findings into action. With our support, the Association for Maternal and Child Health Programs (AMCHP)'s Every Mother Initiative developed and strengthened the capacity of 12 states to review their maternal deaths, identify the root of the problem and implement solutions. The results from the initiative, including the findings and actions of these 12 states, are highlighted in a newly published <a href="http://merckformothers.com/docs/States-Insights.pdf" target="_blank" rel="noopener noreferrer">report</a>. </p>

              <p>Building on this important work, the CDC produced the country's first-ever multi-state <a href="JavaScript:extLink('https://reviewtoaction.org/Report_from_Nine_MMRCs');" rel="noopener noreferrer">report</a> on maternal mortality and the New York City Department of Health and Mental Hygiene published the <a href="https://www1.nyc.gov/assets/doh/downloads/pdf/data/maternal-morbidity-report-08-12.pdf" target="_blank" rel="noopener noreferrer">first citywide analysis</a> of severe maternal morbidity.  </p>

              <h3>Quality Care</h3>

              <p>In partnership with leading provider organizations, <em>{this.MERCK} for Mothers</em> supported implementation of evidence-based practices to improve obstetric care in five states and is now funding the Institute for Healthcare Improvement to <a href="JavaScript:extLink('https://www.businesswire.com/news/home/20180814005116/en/IHI-Joining-Efforts-Improve-Outcomes-Reduce-Disparities');" rel="noopener noreferrer">scale these tools nationally</a>. These “safety bundles"  address the three leading causes of maternal death in the US (hemorrhage, hypertension and embolism),  </p>

              <p>Given that most deaths occur in the postpartum period, we've supported the Association of Women's Health, Obstetric and Neonatal Nurses (AWHONN) to raise awareness of postpartum health risks among nurses and patients. These programs are ensuring that all women receive standard, evidence-based obstetric care and hospital discharge information, regardless of where they give birth.</p>

              <h3>Healthier Communities</h3>

              <p><em>{this.MERCK} for Mothers</em> is also addressing community and social factors that influence a healthy pregnancy and childbirth. Our partners at several community-based organizations are pioneering new integrated care models in which community health workers and doulas support high-risk women throughout and after pregnancy.  With funding from <em>{this.MERCK} for Mothers</em>, researchers from Averting Maternal Death and Disability (AMDD) at Columbia University are conducting groundbreaking research on the experience of women during pregnancy and childbirth. Their focus groups with women in underserved communities will shed light on factors contributing to racial disparities and inform strategies for promoting respectful maternity care.</p>

            </div>
          </div>
          <div className="social-bottom"><Social mfm={MFM} title={this.TITLE} twitterTitle={this.TWITTER_TITLE} url={this.BASE_URL} /></div>
        </div>



        <div className="grey2-area">
          <div ref="grey2" className="grey2-area-inner general">
            <h1>TURNING OUTRAGE INTO ACTION</h1>

            <div className="wrap">
              <div className="left">OUR MOTHERS NEED YOUR VOICE</div>
              <div className="right">

                <strong>Are you ready to make a difference?</strong>

                <p>Our partners at the Preeclampsia Foundation are forming a national coalition of patient organizations and individuals united under a shared agenda to reduce complications in pregnancy and the postpartum period, and to improve maternal health outcomes for all women.</p>
                <p>If you would like to know what you can do to become an advocate and join the fight to reduce maternal mortality in the US, please click below for more information.</p>

                <p><a href="JavaScript:extLink('http://www.mommasvoices.org/');" className="link-btn" rel="noopener noreferrer">Learn More</a></p>
              </div>


            </div>

          </div>
        </div>

        

        <a name="join"></a>
        <div ref="section7" id="section7">
          <div className="bg"></div>
          <div ref="section7_left" className="section7-right">
            <div className="section7-inner">

              <h1>Safer Childbirth Cities Initiative</h1>

              {/* <p><em>{this.MERCK} for Mothers</em> Commits Additional $10M to Support Local Organizations Working to Reduce Disparities and Improve Maternal Health</p>
              <p><em>{this.MERCK} for Mothers</em> is launching a new multi-city initiative to improve outcomes and reduce disparities in maternal health and is seeking Expressions of Interest from eligible city-based organizations across the country. </p>
              <p>The Safer Childbirth Cities Initiative will support U.S. cities with a high burden of maternal mortality and morbidity to implement evidence-informed interventions to reverse the country's increase in pregnancy and childbirth-related deaths and life-threatening complications.</p>
              <p>For more information, please review the call for Expressions of Interest.</p> */}

              <p><em>{this.MERCK} for Mothers</em> is launching a new multi-city initiative to improve outcomes and reduce disparities in maternal health, committing $10M to support local organizations across the country.</p>

              <p>The Safer Childbirth Cities Initiative will support U.S. cities with a high burden of maternal mortality and morbidity to implement evidence-informed interventions to address the country's increase in pregnancy and childbirth-related deaths and life-threatening complications. <em>{this.MERCK} for Mothers</em> is currently reviewing Expressions of Interest and will select a limited number of applicants to submit more detailed proposals in early 2019. <strong><em>Given the high volume of applications we’ve received through the Safer Childbirth Cities initiative, we will be notifying applicants by the end of December. We thank you for your patience.</em></strong></p>

              <p>To receive future information about the Safer Childbirth Cities Initiative, our work in the US and across the globe, please sign up for our email newsletter.</p>

              <a href="http://merckformothers.com/get-involved.html#hear-from-us" className="link-btn" target="_blank" rel="noopener noreferrer">Sign Up</a>



              {/* <p>
              <ReactGA.OutboundLink
                  eventLabel="Safe_Childbirth_Cities_EOI.pdf"
                  to="http://reports.merckformothers.com/us/docs/Safe_Childbirth_Cities_EOI.pdf" 
                  target="_blank" 
                  className="link-btn"
                  rel="noopener noreferrer">Learn More
                </ReactGA.OutboundLink>
              </p> */}

              
            </div>
          </div>
          <div className="social-bottom"><Social mfm={MFM} title={this.TITLE} twitterTitle={this.TWITTER_TITLE} url={this.BASE_URL} /></div>
        </div>

        <a name="MCC"></a>
        <HalfSection />

        <GreenSection />

        <Map2 />


        <div ref="logos" className="white top-pad">
          {window.innerWidth < 800 ?
            <div className="logos">
              <h1>Thank you to our United States Partners:</h1>
              <img ref="logos1" src={logosMobile} alt="logos" />
            </div>

          :
            <div className="logos">
              <h1>Thank you to our United States Partners:</h1>
              <img ref="logos1" src={logos1} alt="logos" />
              <img ref="logos2" src={logos2} alt="logos" />
              <img ref="logos3" src={logos3} alt="logos" />
              <img ref="logos4" src={logos4} alt="logos" />
              <img ref="logos5" src={logos5} alt="logos" />
            </div>
          }

        </div>
        <div className="grey-area">
          <div className="grey-area-inner general">
            <h1>STAY INFORMED</h1>

            <p>Receive our email newsletter</p>

            <a href="http://merckformothers.com/get-involved.html#hear-from-us" className="link-btn" target="_blank" rel="noopener noreferrer">Sign Up</a>


              {/* {MFM === true ?
                <div className="end-logo">
                  <a href="http://www.merckformothers.com" target="_blank" rel="noopener noreferrer"><img src={merckLogo} alt="Merck" /></a>
                  <a href="http://www.merckformothers.com" target="_blank" rel="noopener noreferrer">www.merckformothers.com</a>
                </div>
                :
                <div className="end-logo">
                  <a href="http://www.msdformothers.com" target="_blank" rel="noopener noreferrer"><img src={msdLogo} alt="MSD" /></a>
                  <a href="http://www.msdformothers.com" target="_blank" rel="noopener noreferrer">www.msdformothers.com</a>
                </div>
              } */}
          </div>
        </div>

        <div className="citations">
          <div className="citations-inner">

            <strong>Citations:</strong>

            <p>1 <a href="JavaScript:extLink('https://www.cdc.gov/reproductivehealth/maternalinfanthealth/pregnancy-mortality-surveillance-system.htm');" rel="noopener noreferrer">https://www.cdc.gov/reproductivehealth/maternalinfanthealth/pregnancy-mortality-surveillance-system.htm</a></p>

            <p>2 <a href="JavaScript:extLink('http://apps.who.int/iris/bitstream/handle/10665/194254/9789241565141_eng.pdf;jsessionid=3D098691525567DDC8ABBBF99680E464?sequence=1');" rel="noopener noreferrer">http://apps.who.int/iris/bitstream/handle/10665/194254/9789241565141_eng.pdf;jsessionid=3D098691525567DDC8ABBBF99680E464?sequence=1</a></p>

            <p>3 <a href="http://reviewtoaction.org/sites/default/files/national-portal-material/Report from Nine MMRCs final_0.pdf" target="_blank" rel="noopener noreferrer">http://reviewtoaction.org/sites/default/files/national-portal-material/Report from Nine MMRCs final_0.pdf</a></p>

            <p>4 <a href="JavaScript:extLink('https://www.cdc.gov/reproductivehealth/maternalinfanthealth/pregnancy-relatedmortality.htm');" rel="noopener noreferrer">https://www.cdc.gov/reproductivehealth/maternalinfanthealth/pregnancy-relatedmortality.htm</a></p>

            <p>
              5 <a href="https://www.cdcfoundation.org/sites/default/files/files/MMRIAReport.pdf" target="_blank" rel="noopener noreferrer">https://www.cdcfoundation.org/sites/default/files/files/MMRIAReport.pdf</a>
            </p>

          </div>
        </div>


        <Modal
          isOpen={this.state.video1}
          style={customStyles}
          onRequestClose={this._close}
        >

          <div><iframe title="video1" width="560" height="315" src="https://www.youtube.com/embed/EOtbelVbE-U" frameBorder="0" allow="autoplay; encrypted-media" allowFullScreen></iframe></div>
        </Modal>


        <Modal
          isOpen={this.state.video2}
          style={customStyles}
          onRequestClose={this._close}
        >

          <div><iframe title="video2" width="560" height="315" src="https://www.youtube.com/embed/tr4d6BT6O4w" frameBorder="0" allow="autoplay; encrypted-media" allowFullScreen></iframe></div>
        </Modal>
      </div>
    );
  }

  _video1() {
    this.setState({video1: true});
  }

  _video2() {
    this.setState({video2: true});
  }

  _close() {
    this.setState({video1: false, video2: false});
  }

  _scroll() {


    if(window.innerWidth < 800) return;

    const scroll =  document.documentElement.scrollTop || document.body.scrollTop;

    if(!this.state.scrolled && scroll > 100) {
      this.setState({scrolled: true});
    }

    if(scroll < window.innerHeight*2) {
      let pct = scroll / (window.innerHeight*2);

      let t = window.innerHeight/2 * pct;
      this.refs.rings.style.display = 'flex';
      this.refs.headerText.style.display = this.refs.btnPlay.style.display = 'block';
      this.refs.rings.style.transform = 'translateY('+t+'px)';

      this.refs.headerText.style.opacity = this.refs.btnPlay.style.opacity = 1-pct*3;

    } else {
      if(this.refs.rings.style.display !== 'none') {
        this.refs.rings.style.display = 'none';
        this.refs.headerText.style.display = this.refs.btnPlay.style.display = 'none';
      }

    }

    if(
      scroll > this._fromTop(this.refs.section2)-window.innerHeight
      && scroll < this._fromTop(this.refs.section2) + this.refs.section2.offsetHeight
    ) {
      var pct = 1- ((this._fromTop(this.refs.section2)-scroll) / this.refs.section2.offsetHeight);
      pct *= 0.8;
      if(pct > 1) {
        pct = 1;
      }

      var n = 100*(1-pct);
      this.refs.rest1.style.transform = 'translateX('+n*0.3+'%)';
      //this.refs.rest2.style.transform = 'translateX('+n*0.6+'%)';
      this.refs.rest3.style.transform = 'translateX('+n+'%)';
    }

    /*if(scroll > this._fromTop(this.refs.expanded)-window.innerHeight) {
      let pct = 1- ((this._fromTop(this.refs.expanded)-scroll) / window.innerHeight);
      if(pct > 1) {
        pct = 1;
      }

      let n = 1+(0.3*pct);
      this.refs.expanded.style.transform = 'scale('+n+')';
    }*/


    if(scroll > this._fromTop(this.refs.green)-window.innerHeight) {
      let pct = 1- ((this._fromTop(this.refs.green)-scroll) / this.refs.green.offsetHeight);
      if(pct > 1) {
        pct = 1;
      }

      let p = document.getElementById("half60");
      let t = document.getElementById("half34");
      let final = 60 * pct;
      p.innerHTML = Math.ceil(final) + '%';
      let fff = '1x';
      if(pct < .25) {
        fff = "1x";
      } else {
        if(pct < .80) {
          fff = "2x";
        } else {
          if(pct < .95) {
            fff = "3x";
          } else {
            fff = "3-4x";
          }
        }
      }

      t.innerHTML = fff;



      let n = -100*(1-pct);
      this.refs.green1.style.transform = 'translateX('+n+'%)';
      this.refs.green2.style.transform = 'translateX('+(-n)+'%)';
    }


    if(scroll > this._fromTop(this.refs.list)-window.innerHeight) {
      let pct = 1- ((this._fromTop(this.refs.green)-scroll) / this.refs.green.offsetHeight);

      if(pct > 1) {
        pct = 1;
      }

      let tag = document.getElementById('usa');
      if(pct > -0.306) {
        tag.className = 'usa popout';
      } else {
        tag.className = 'usa';

      }
    }


    if(scroll > this._fromTop(this.refs.purple1)-window.innerHeight) {
      let pct = 1- ((this._fromTop(this.refs.purple1)-scroll) / (window.innerHeight));
      //console.log(pct);
      //pct *= 0.6;
      pct *= 1.2;

      this.refs.purple1.style.opacity = pct;
    }

    if(scroll > this._fromTop(this.refs.purple2)-window.innerHeight) {
      let pct = 1- ((this._fromTop(this.refs.purple2)-scroll) / (window.innerHeight));
      //console.log(pct);
      //pct *= 0.6;
      pct *= 1.2;

      if(pct > 1) {
        pct = 1;
      }

      let n = -100*(1-pct);
      this.refs.purple2.style.transform = 'translateX('+n+'%)';
    }

    if(scroll > this._fromTop(this.refs.purple3)-window.innerHeight) {
      let pct = 1- ((this._fromTop(this.refs.purple3)-scroll) / (window.innerHeight));
      //console.log(pct);
      //pct *= 0.6;
      pct *= 1.2;

      this.refs.purple3.style.opacity = pct;
    }

    if(scroll > this._fromTop(this.refs.purple4)-window.innerHeight) {
      let pct = 1- ((this._fromTop(this.refs.purple4)-scroll) / (window.innerHeight));
      //console.log(pct);
      //pct *= 0.6;
      pct *= 1.2;

      if(pct > 1) {
        pct = 1;
      }

      let n = -100*(1-pct);
      this.refs.purple4.style.transform = 'translateX('+n+'%)';
    }

    if(scroll > this._fromTop(this.refs.purple5)-window.innerHeight) {
      let pct = 1- ((this._fromTop(this.refs.purple5)-scroll) / (window.innerHeight));
      //console.log(pct);
      //pct *= 0.6;
      pct *= 1.2;

      this.refs.purple5.style.opacity = pct;
    }


    if(scroll > this._fromTop(this.refs.purple6)-window.innerHeight) {
      let pct = 1- ((this._fromTop(this.refs.purple6)-scroll) / (window.innerHeight));
      //console.log(pct);
      //pct *= 0.6;
      pct *= 1.2;

      if(pct > 1) {
        pct = 1;
      }

      let n = -100*(1-pct);
      this.refs.purple6.style.transform = 'translateX('+n+'%)';
    }

    if(scroll > this._fromTop(this.refs.purple7)-window.innerHeight) {
      let pct = 1- ((this._fromTop(this.refs.purple7)-scroll) / (window.innerHeight));
      //console.log(pct);
      //pct *= 0.6;
      pct *= 1.2;

      this.refs.purple7.style.opacity = pct;
    }



    if(scroll > this._fromTop(this.refs.grey2)-window.innerHeight) {
      let pct = 1- ((this._fromTop(this.refs.grey2)-scroll) / window.innerHeight);
      pct *= 1.5;

      if(pct > 1) {
        pct = 1;
      }

      let n = -100*(1-pct);
      this.refs.grey2.style.transform = 'translateX('+n+'%)';
    }

/*
    if(scroll > this._fromTop(this.refs.blue)-window.innerHeight) {
      let pct = 1- ((this._fromTop(this.refs.blue)-scroll) / (window.innerHeight));
      pct *= 1.5;
      if(pct > 1) {
        pct = 1;
      }

      let n = 100*(1-pct);
      this.refs.blue.style.transform = 'translateX('+n+'%)';
    }*/

    if(scroll > this._fromTop(this.refs.logos)-window.innerHeight-100) {
      let pct = 1- ((this._fromTop(this.refs.logos)-scroll) / this.refs.logos.offsetHeight);

      if(pct > 1) {
        pct = 1;
      }

      let n = -100*(1-pct);
      this.refs.logos1.style.transform = 'translateX('+n+'%)';
      this.refs.logos2.style.transform = 'translateX('+n*-0.2+'%)';
      this.refs.logos3.style.transform = 'translateX('+n*0.4+'%)';
      this.refs.logos4.style.transform = 'translateX('+n*-0.6+'%)';
      this.refs.logos5.style.transform = 'translateX('+n*0.6+'%)';
    }


    var l = document.getElementById("list-title");
    var g = document.getElementById("list-gradient");
    if(scroll > this._fromTop(this.refs.list)) {

      if(scroll > this._fromTop(this.refs.list) + this.refs.list.offsetHeight) {
        l.className = 'fixed-title-bye';
        g.className = 'fixed-gradient-bye';
      } else {
        l.className = 'fixed-title';
        g.className = 'fixed-gradient';
      }
    } else {
      l.className = '';
      g.className = '';
    }




    //SECTION 3
    /*if(scroll >= this._fromTop(this.refs.section3)
      && scroll < this._fromTop(this.refs.section3) + this.refs.section3.offsetHeight
    ) {
      if(scroll >= this._fromTop(this.refs.section3) + this.refs.section3.offsetHeight - window.innerHeight) {
        this.refs.section3.className = 'absolute-bottom';
      } else {
        this.refs.section3.className = 'fixed';
      }

      if(scroll >= this._fromTop(this.refs.section3) + this.refs.section3_left.offsetHeight - window.innerHeight) {
        if(scroll > this._fromTop(this.refs.section3) + this.refs.section3.offsetHeight - window.innerHeight) {
          this.refs.section3_left.style.top = Math.ceil(this.refs.section3.offsetHeight-this.refs.section3_left.offsetHeight)+'px';
        } else {
          let pixels = (this._fromTop(this.refs.section3) + this.refs.section3_left.offsetHeight - window.innerHeight) - scroll;
          pixels *= -1;
          this.refs.section3_left.style.top = pixels+'px';
        }

        this.refs.section3_left.style.filter = 'blur(2px)';

      } else {
        this.refs.section3_left.style.top = '0px';
        this.refs.section3_left.style.filter = '';
      }

    } else {
      this.refs.section3.className = '';
    }*/



    if(scroll >= this._fromTop(this.refs.section4)
      && scroll < this._fromTop(this.refs.section4) + this.refs.section4.offsetHeight
    ) {

      if(scroll >= this._fromTop(this.refs.section4) + this.refs.section4.offsetHeight - window.innerHeight) {
        this.refs.section4.className = 'absolute-bottom';
      } else {
        this.refs.section4.className = 'fixed';
      }

      if(scroll >= this._fromTop(this.refs.section4) + this.refs.section4_left.offsetHeight - window.innerHeight) {
        if(scroll > this._fromTop(this.refs.section4) + this.refs.section4.offsetHeight - window.innerHeight) {
          this.refs.section4_left.style.top = Math.ceil(this.refs.section4.offsetHeight-this.refs.section4_left.offsetHeight)+'px';
        } else {
          let pixels = (this._fromTop(this.refs.section4) + this.refs.section4_left.offsetHeight - window.innerHeight) - scroll;
          pixels *= -1;
          this.refs.section4_left.style.top = pixels+'px';
        }

        //this.refs.section4_left.style.filter = 'blur(2px)';

      } else {
        this.refs.section4_left.style.top = '0px';
        //this.refs.section4_left.style.filter = '';
      }

    } else {
      this.refs.section4.className = '';
    }


    if(scroll >= this._fromTop(this.refs.section6)
      && scroll < this._fromTop(this.refs.section6) + this.refs.section6.offsetHeight
    ) {
      if(scroll >= this._fromTop(this.refs.section6) + this.refs.section6.offsetHeight - window.innerHeight) {
        this.refs.section6.className = 'absolute-bottom';
      } else {
        this.refs.section6.className = 'fixed';
      }

      if(scroll >= this._fromTop(this.refs.section6) + this.refs.section6_left.offsetHeight - window.innerHeight) {
        if(scroll > this._fromTop(this.refs.section6) + this.refs.section6.offsetHeight - window.innerHeight) {
          this.refs.section6_left.style.top = Math.ceil(this.refs.section6.offsetHeight-this.refs.section6_left.offsetHeight)+'px';
        } else {
          let pixels = (this._fromTop(this.refs.section6) + this.refs.section6_left.offsetHeight - window.innerHeight) - scroll;
          pixels *= -1;
          this.refs.section6_left.style.top = pixels+'px';
        }

        //this.refs.section6_left.style.filter = 'blur(2px)';

      } else {
        this.refs.section6_left.style.top = '0px';
        //this.refs.section6_left.style.filter = '';
      }

    } else {
      this.refs.section6.className = '';
    }




    if(scroll >= this._fromTop(this.refs.section7)
      && scroll < this._fromTop(this.refs.section7) + this.refs.section7.offsetHeight
    ) {

      if(scroll >= this._fromTop(this.refs.section7) + this.refs.section7.offsetHeight - window.innerHeight) {
        this.refs.section7.className = 'absolute-bottom';
        // this.refs.section7.className = '';
      } else {
        this.refs.section7.className = 'fixed';
      }

      if(scroll >= this._fromTop(this.refs.section7) + this.refs.section7_left.offsetHeight - window.innerHeight) {
        if(scroll > this._fromTop(this.refs.section7) + this.refs.section7.offsetHeight - window.innerHeight) {
          this.refs.section7_left.style.top = Math.ceil(this.refs.section7.offsetHeight-this.refs.section7_left.offsetHeight)+'px';
        } else {
          let pixels = (this._fromTop(this.refs.section7) + this.refs.section7_left.offsetHeight - window.innerHeight) - scroll;
          pixels *= -1;
          this.refs.section7_left.style.top = pixels+'px';
        }

        //this.refs.section7_left.style.filter = 'blur(2px)';

      } else {
        this.refs.section7_left.style.top = '0px';
        //this.refs.section7_left.style.filter = '';
      }

    } else {
      // this.refs.section7.className = 'section7BG';
      this.refs.section7.className = '';
    }



  }

  _fromTop( elem ) {
    var location = 0;
    if(elem) {
      if (elem.offsetParent) {
          do {
            location += elem.offsetTop;
            if(elem) {
              elem = elem.offsetParent;
            } else {
              elem = null;
            }

          } while (elem);
      }
    }

    return location >= 0 ? location : 0;
  }

  _play() {
    if(this.state.playing) {
      this.wavesurfer.pause();
      this.setState({playing: false});
    } else {
      this.wavesurfer.play();
      this.setState({playing: true});
    }
  }


  _resize() {
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/js/App.js